<template>
    <common-chart chart-id="gradeRate" :options="options"></common-chart>
</template>

<script>
import CommonChart from "@/components/echarts-part/kpi/stuff/CommonChart";

export default {
    name: "GradeRatePie",
    components: {CommonChart},
    computed: {
        options() {
            return {
                title: {
                    text: '成品铬铁',
                    subtext: '',
                    left: '15%',
                    textStyle: {
                        color: '#ddd'
                    }
                },
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    top: 'center',
                    orient: 'vertical',
                    left: '15%',
                    textStyle: {
                        color: '#ddd'
                    }
                },
                series: [
                    {
                        name: '合格率',
                        type: 'pie',
                        radius: ['70%', '90%'],
                        avoidLabelOverlap: false,
                        // itemStyle: {
                        //     borderRadius: 5,
                        //     // borderColor: '#fff',
                        //     borderWidth: 1
                        // },
                        label: {
                            show: false,
                            position: 'center'
                        },
                        left: '30%',
                        // emphasis: {
                        //     label: {
                        //         show: true,
                        //         fontSize: '40',
                        //         fontWeight: 'bold'
                        //     }
                        // },
                        labelLine: {
                            show: false
                        },
                        data: [
                            {
                                value: 1048, name: '合格',
                                itemStyle: {
                                    color: '#627ad3'
                                }
                            },
                            {
                                value: 115, name: '不合格',
                                itemStyle: {
                                    color: '#de6e6a'
                                }
                            },
                        ]
                    },
                    {
                        name: '一级品率',
                        type: 'pie',
                        radius: [0, '40%'],
                        label: {
                            show: false,
                            position: 'inner',
                            fontSize: 14
                        },
                        left: '30%',
                        labelLine: {
                            show: false
                        },
                        data: [
                            {
                                value: 648, name: '一级品',
                                itemStyle: {
                                    color: '#9eca7f'
                                }
                            },
                            {
                                value: 400, name: '二级品',
                                itemStyle: {
                                    color: '#f2ca6b'
                                }
                            }
                        ]
                    }
                ]
            };
        }
    }
}
</script>

<style scoped>

</style>